//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets data.
 * @param invoiceNumber (optional) 
 * @param isOverdueDebt (optional) 
 * @param debt (optional) 
 * @param repaid (optional) 
 * @param credited (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function get(invoiceNumber?: string | undefined, isOverdueDebt?: boolean | undefined, debt?: boolean | undefined, repaid?: boolean | undefined, credited?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.OutstandingReceivablesResponseDto> {
    let url_ = getBaseUrl() + "/api/outstanding-receivables?";
    if (invoiceNumber === null)
        throw new Error("The parameter 'invoiceNumber' cannot be null.");
    else if (invoiceNumber !== undefined)
        url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
    if (isOverdueDebt === null)
        throw new Error("The parameter 'isOverdueDebt' cannot be null.");
    else if (isOverdueDebt !== undefined)
        url_ += "IsOverdueDebt=" + encodeURIComponent("" + isOverdueDebt) + "&";
    if (debt === null)
        throw new Error("The parameter 'debt' cannot be null.");
    else if (debt !== undefined)
        url_ += "Debt=" + encodeURIComponent("" + debt) + "&";
    if (repaid === null)
        throw new Error("The parameter 'repaid' cannot be null.");
    else if (repaid !== undefined)
        url_ += "Repaid=" + encodeURIComponent("" + repaid) + "&";
    if (credited === null)
        throw new Error("The parameter 'credited' cannot be null.");
    else if (credited !== undefined)
        url_ += "Credited=" + encodeURIComponent("" + credited) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.OutstandingReceivablesResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initOutstandingReceivablesResponseDto(resultData200);
        return Promise.resolve<Types.OutstandingReceivablesResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.OutstandingReceivablesResponseDto>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}